import type React from 'react'

import { MotionIllust } from '@/components/parts/motion-illust'

type StatusMessageProps = {
  /** 見出し。ページの h1 になる */
  title: string
  /** 本文。段落ごとに `<p>` で渡す（段落の間は Figma の空行 1 行分あける） */
  children: React.ReactNode
  /** 見出しの上に置く 240×240 のイラスト（public/images 配下のモーション SVG）。SP は 168×168 */
  illustSrc?: string
  /** ヘッダーを除いた 1 画面ぶんの高さにして、中身を上下中央に置く（サンクス・送信エラー・404） */
  fillScreen?: boolean
}

/**
 * フォーム送信後のサンクス・送信エラー・404 で使う、イラスト・見出し・本文のセクション
 * （Figma: （PC）お問い合わせ_お問い合わせ_サンクス ほか 4 画面の sec/）
 */
export const StatusMessage = ({
  title,
  children,
  illustSrc,
  fillScreen = false
}: StatusMessageProps) => {
  return (
    <section
      data-status-screen={fillScreen || undefined}
      className={`bg-surface-subtle px-6 py-16 lg:p-panelx ${
        fillScreen ? 'flex min-h-status-screen flex-col justify-center' : ''
      }`}
    >
      {/* イラストと文字の間は 56px */}
      <div className="mx-auto flex max-w-wide flex-col items-center gap-14 text-center text-ink">
        {illustSrc ? (
          <MotionIllust
            src={illustSrc}
            alt=""
            width={240}
            height={240}
            className="size-illust-status-sp shrink-0 md:size-illust"
            loading="eager"
          />
        ) : null}
        <div className="flex flex-col items-center gap-6">
          {/* SP で 1〜2 文字だけ次の行に落ちないよう、行の長さを揃える */}
          <h1 className="fontfeaturesettings text-balance text-2xl font-bold leading-heading tracking-heading md:text-h2">
            {title}
          </h1>
          <div className="flex flex-col gap-7 text-balance text-base leading-body">
            {children}
          </div>
        </div>
      </div>
    </section>
  )
}
